(function () {
  'use strict';

  var TRANSITION_MS = 300;

  function init(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-cutting-tab]'));
    var panels = root.querySelectorAll('[data-cutting-panel]');
    var mobileBar = root.querySelector('[data-cutting-mobile-bar]');
    var mobileLabel = root.querySelector('[data-cutting-mobile-label]');
    var mobileDrawer = root.querySelector('[data-cutting-mobile-drawer]');
    var mobileToggle = root.querySelector('[data-cutting-mobile-toggle]');
    var count = panels.length;
    var index = 0;
    var transitioning = false;

    if (!count) return;

    function panelLabel(i) {
      var tab = tabs.find(function (el) {
        return parseInt(el.getAttribute('data-cutting-tab'), 10) === i;
      });
      if (!tab) return '';
      var num = String(i + 1).padStart(2, '0');
      return num + '. ' + tab.textContent.trim();
    }

    function syncTabs() {
      tabs.forEach(function (tab) {
        var tabIndex = parseInt(tab.getAttribute('data-cutting-tab'), 10);
        tab.classList.toggle('is-active', tabIndex === index);
      });
    }

    function updateMobileLabel() {
      if (mobileLabel) mobileLabel.textContent = panelLabel(index);
    }

    function setDrawerOpen(open) {
      if (!mobileDrawer || !mobileToggle) return;
      mobileDrawer.classList.toggle('is-open', open);
      mobileToggle.classList.toggle('is-open', open);
      mobileDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    }

    function activate(nextIndex) {
      if (nextIndex < 0 || nextIndex >= count || nextIndex === index || transitioning) return;

      transitioning = true;
      var prevPanel = panels[index];
      var nextPanel = panels[nextIndex];

      prevPanel.classList.remove('is-current');
      prevPanel.classList.add('is-leaving');

      index = nextIndex;
      syncTabs();
      nextPanel.removeAttribute('hidden');
      nextPanel.classList.add('is-entering');

      window.requestAnimationFrame(function () {
        nextPanel.classList.remove('is-entering');
        nextPanel.classList.add('is-current');
      });

      window.setTimeout(function () {
        prevPanel.classList.remove('is-leaving');
        prevPanel.setAttribute('hidden', '');
        transitioning = false;
      }, TRANSITION_MS);

      updateMobileLabel();
      setDrawerOpen(false);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(parseInt(tab.getAttribute('data-cutting-tab'), 10));
      });
    });

    if (mobileBar) {
      mobileBar.addEventListener('click', function () {
        setDrawerOpen(!mobileDrawer.classList.contains('is-open'));
      });
    }

    updateMobileLabel();
  }

  function bootstrap() {
    document.querySelectorAll('[data-cutting-manual]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
